"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import { useRef } from "react";
import { ButtonRadialFill } from "@/components/button-radial-fill";
import { usePageTransition } from "@/components/page-transition-provider";
import Avatars from "~/public/assets/avatars.png";
import { useCTAContactTeamAnimation } from "./use-cta-contact-team-animation";
export type CTAContactSectionProps = {
  ctaTitle?: string;
  ctaSubtitle?: string;
  ctaLabel?: string;
  ctaHref?: string;
  footer?: string;
  hasNumbers?: boolean;
  /** Só precisa ser informado quando a mesma página renderiza a webpart mais de uma vez. */
  id?: string;
};
export default function CTAContactSection(t0) {
  const $ = _c(26);
  const {
    ctaTitle: t1,
    ctaSubtitle: t2,
    ctaLabel: t3,
    ctaHref: t4,
    footer: t5,
    hasNumbers: t6,
    id: t7
  } = t0;
  const ctaTitle = t1 === undefined ? "Pronto para o pr\xF3ximo n\xEDvel?" : t1;
  const ctaSubtitle = t2 === undefined ? "Do discovery ao deploy. Estamos prontos para come\xE7ar." : t2;
  const ctaLabel = t3 === undefined ? "Agendar reuni\xE3o" : t3;
  const ctaHref = t4 === undefined ? "/contato" : t4;
  const footer = t5 === undefined ? "Constru\xEDmos software com met\xF3do, qualidade e velocidade." : t5;
  const hasNumbers = t6 === undefined ? true : t6;
  const id = t7 === undefined ? "why-flowlab-cta-contact" : t7;
  const sectionRef = useRef(null);
  const {
    navigate
  } = usePageTransition();
  useCTAContactTeamAnimation(sectionRef);
  const t8 = `md:container-padding relative border-b border-gray-300 text-white
            ${hasNumbers ? "" : "bg-gray-1100"}`;
  let t9;
  if ($[0] !== ctaTitle) {
    t9 = <h3 className="text-xl font-semibold leading-[140%] md:text-2xl">{ctaTitle}</h3>;
    $[0] = ctaTitle;
    $[1] = t9;
  } else {
    t9 = $[1];
  }
  let t10;
  if ($[2] !== ctaSubtitle) {
    t10 = <p className="mt-1 text-sm leading-[150%] text-gray-100/55">{ctaSubtitle}</p>;
    $[2] = ctaSubtitle;
    $[3] = t10;
  } else {
    t10 = $[3];
  }
  let t11;
  if ($[4] !== t10 || $[5] !== t9) {
    t11 = <div>{t9}{t10}</div>;
    $[4] = t10;
    $[5] = t9;
    $[6] = t11;
  } else {
    t11 = $[6];
  }
  let t12;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <Image src={Avatars} alt="Equipe Flow" className="w-full max-w-42" width={1000} height={1000} />;
    $[7] = t12;
  } else {
    t12 = $[7];
  }
  let t13;
  if ($[8] !== ctaHref || $[9] !== navigate) {
    t13 = event => {
      navigate(ctaHref, {
        origin: {
          x: event.clientX,
          y: event.clientY
        }
      });
    };
    $[8] = ctaHref;
    $[9] = navigate;
    $[10] = t13;
  } else {
    t13 = $[10];
  }
  let t14;
  if ($[11] !== ctaLabel || $[12] !== t13) {
    t14 = <div className="flex flex-wrap items-center gap-9 md:flex-nowrap">{t12}<ButtonRadialFill className="h-14.5 px-6 rounded-2xl border border-primary-300 bg-primary-300" classNameFill="bg-gray-1100" onClick={t13}>{ctaLabel}</ButtonRadialFill></div>;
    $[11] = ctaLabel;
    $[12] = t13;
    $[13] = t14;
  } else {
    t14 = $[13];
  }
  let t15;
  if ($[14] !== t11 || $[15] !== t14) {
    t15 = <div className="why-flowlab-cta max-w-fit mx-auto flex flex-col gap-16 rounded-3xl border border-primary-300/50 p-9 lg:flex-row md:items-center md:justify-between">{t11}{t14}</div>;
    $[14] = t11;
    $[15] = t14;
    $[16] = t15;
  } else {
    t15 = $[16];
  }
  let t16;
  if ($[17] !== footer) {
    t16 = footer ? <p className="why-flowlab-footer mx-auto mt-8 text-center text-gray-500">{footer}</p> : null;
    $[17] = footer;
    $[18] = t16;
  } else {
    t16 = $[18];
  }
  let t17;
  if ($[19] !== t15 || $[20] !== t16) {
    t17 = <div className="container relative z-10 border-gray-300 pb-20 md:border-x md:pb-28 px-6 lg:px-18 3xl:px-24!">{t15}{t16}</div>;
    $[19] = t15;
    $[20] = t16;
    $[21] = t17;
  } else {
    t17 = $[21];
  }
  let t18;
  if ($[22] !== id || $[23] !== t17 || $[24] !== t8) {
    t18 = <section ref={sectionRef} className={t8} id={id}>{t17}</section>;
    $[22] = id;
    $[23] = t17;
    $[24] = t8;
    $[25] = t18;
  } else {
    t18 = $[25];
  }
  return t18;
}